import detectTouch from '../../../../scripts/utilities/detect-touch';
import * as hammer from 'hammerjs';
import {body, element} from './constants';

const activate = () => {
	if ( !body.classList.contains('is-active-search') ) {
		body.classList.add('is-active-search');
	}
}

const deactivate = () => {
	if ( body.classList.contains('is-active-search') ) {
		body.classList.remove('is-active-search');
	}
}

const toggleActive = () => {
	if ( body.classList.contains('is-active-search') ) {
		body.classList.remove('is-active-search');
	} else {
		body.classList.add('is-active-search');
	}
}

const handleTouch = () => {
	new Hammer(element.parent, {threshold: 20}).on('tap', () => activate());
	element.close.onclick = () => deactivate();
}

const handleClick = () => {
	hoverintent(element.parent,
		()=>toggleActive(),
		()=>toggleActive()
	).options({
		timeout: 100,
		interval: 40
	});
}

export default function() {
	if ( element.parent ) {
		if ( detectTouch() ) handleTouch();
		if ( !detectTouch() ) handleClick();
	}
}
